import type { Ref } from 'react';
import { forwardRef } from 'react';
import type {
  GridProps as SystemGridProps,
  JustifyContentProps,
  JustifyItemsProps,
} from 'styled-system';

import type { BoxProps, ResponsiveSpaceType } from '@/components/Box';

import * as S from './Grid.styles';

export interface GridProps
  extends Omit<SystemGridProps, 'gridGap' | 'gridColumnGap' | 'gridRowGap'>,
    BoxProps,
    JustifyContentProps,
    JustifyItemsProps {
  gridColumnGap?: ResponsiveSpaceType;
  gridGap?: ResponsiveSpaceType;
  gridRowGap?: ResponsiveSpaceType;
}

export const Grid = forwardRef((props: GridProps, ref: Ref<HTMLElement>) => {
  const { as, ...rest } = props;
  return <S.Grid ref={ref} data-test-id='Grid' forwardedAs={as} {...rest} />;
});

Grid.defaultProps = {
  as: 'div',
};

Grid.displayName = 'Grid';
